import React from "react";
import { Tooltip, Image } from "antd";
import styled from "styled-components";

export interface WikipediaLinkProps {
  href: string;
  size?: number;
}

const LinkAnchor = styled.a<{ $size: number }>`
  display: inline-block;
  height: ${(p) => p.$size}px;
`;

const LinkImage = styled(Image)`
  display: block;
`;

export function WikipediaLink({ href, size = 18 }: WikipediaLinkProps) {
  const stop = (e: React.SyntheticEvent) => e.stopPropagation();

  return (
    <Tooltip title="Open Wikipedia">
      <LinkAnchor
        href={href}
        target="_blank"
        rel="noreferrer"
        onClick={stop}
        onMouseDown={stop}
        $size={size}
      >
        <LinkImage
          src="/icons/wikipedia.png"
          alt="Wikipedia"
          width={size}
          height={size}
          preview={false}
        />
      </LinkAnchor>
    </Tooltip>
  );
}
